import { getOptions, logger, VerificationStep } from '@sheerid/jslib';

const QUERY_STRING_PREV_STEP_OVERRIDE: string = 'mockPreviousStep';

export const getPreviousStepOverride = (): VerificationStep | undefined => {
    try {
        const parsed: URLSearchParams = new URLSearchParams(window.location.search);

        if (parsed.get(QUERY_STRING_PREV_STEP_OVERRIDE)) {
            return parsed.get(QUERY_STRING_PREV_STEP_OVERRIDE) as VerificationStep;
        }
        if (getOptions()[QUERY_STRING_PREV_STEP_OVERRIDE]) {
            return getOptions()[QUERY_STRING_PREV_STEP_OVERRIDE];
        }
    } catch (e) {
        logger.error(e as any, QUERY_STRING_PREV_STEP_OVERRIDE);
    }
};
